class Input
{

    constructor(elem)
    {
        this.input = elem;
        this.arReturn = '';
    }

    initialize()
    {
        const that = this;

        // this.input.on('focus, blur, input', function() {
        //   if (!that.input.is('.js-valid-header') && !that.input.is('[data-input-trim]') && !that.input.is('.js-valid-name') && !that.input.is('.js-valid-surname')) {
        //     that.input.val(that.input.val().trim());
        //   }
        // });

        $('[data-delivery-time-form]').on('change', function(e) {
            $.magnificPopup.close();
        });

        $('[data-delivery-day-form]').on('change', function(e) {
            $.magnificPopup.close();
        });
    }

    // поиск в шапке
    initializeSearch()
    {
        let search = this.input;
        let suggestions = search.closest('form').find('[data-suggestions]');
        let result = suggestions.find('[data-suggestions-result]');
        let noresult = suggestions.find('[data-suggestions-null]');
        let searchResults = suggestions.find('[data-suggestions-results]');
        let category = suggestions.find('[data-suggestions-category]');
        let categoryTitle = suggestions.find('[data-suggestions-category-title]');
        let categoryList = suggestions.find('[data-suggestions-category-list]');
        let resultTitle = suggestions.find('[data-suggestions-result-value]');
        let buttonSearchAll = suggestions.find('[data-search-all]');
        let searchIcon = $('[data-search-icon]')
        let body = $('body');

        let searchTimeout = null;

        const that = this;

        search.on('click', (e) => {
            suggestions.show();
            suggestions.closest('form').addClass('active');

            if ($(window).width() < 992) {
                $('html').addClass('overflow');
                $('body').addClass('overflow');
                $('page').addClass('overflow');

                $('html').css({
                    '--app-height': `${$(window).height()}px`,
                    '--app-vh': `${$(window).height() / 100}px`,
                });
            }
        });

        search.off('input').on('input', (e) => {
            clearTimeout(searchTimeout);

            searchTimeout = setTimeout(
                function () {
                    let el = e.target;

                    if (el.value.length > 2) {
                        let query = el.value;

                        $('html').css({
                            '--app-height': `${$(window).height()}px`,
                            '--app-vh': `${$(window).height() / 100}px`,
                        });

                        let _ajax = search.data('ajax');

                        if (_ajax) {
                            _ajax.abort();
                        }

                        if ($('[data-preloader]').length > 0) {
                            $('[data-preloader]').show();
                        }

                        _ajax = $.ajax({
                            url: window.langUrl + '/local/ajax/search.php?ajax_reload=Y',
                            method: 'POST',
                            dataType: 'html',
                            data: {
                                q: query,
                                fast_search: 'y',
                            },
                        }).done(function(response) {
                            searchResults.html(response);

                            if ($('[data-header-search-empty]').length > 0) {
                                buttonSearchAll.addClass('d-none')
                            } else {
                                buttonSearchAll.removeClass('d-none')
                            }

                            that.updateLazy();

                            if ($('[data-preloader]').length > 0) {
                                $('[data-preloader]').hide();
                            }
                        }).fail(function(response) {
                            console.log(response);
                        });

                        resultTitle.text(el.value);
                        buttonSearchAll.attr('href', window.langUrl + '/search/?q=' + el.value)

                        search.data('ajax', _ajax);
                        noresult.hide();
                        result.show();

                    } else {
                        noresult.show();
                        result.hide();
                    }

                    if (el.value.length < 1) {
                        suggestions.hide();
                        suggestions.closest('form').removeClass('active');
                        $('html').removeClass('overflow');
                        $('body').removeClass('overflow');
                        $('page').removeClass('overflow');
                    } else {
                        suggestions.show();
                        suggestions.closest('form').addClass('active');

                        if ($(window).width() < 992) {
                            $('html').addClass('overflow');
                            $('body').addClass('overflow');
                            $('page').addClass('overflow');

                            $('html').css({
                                '--app-height': `${$(window).height()}px`,
                                '--app-vh': `${$(window).height() / 100}px`,
                            });
                        }
                    }
                },
                500
            );
        });

        /**
         * Обработчик по клику подставляет текст запроса в форму поиска и запускает поиск
         */
        categoryList.find('a').on('click', function(e) {
            e.preventDefault();
            var $this = $(this),
                q = $this.text();

            search.val(q);
            search.trigger('input');
        });

        searchIcon.on('click', function(e) {
            let form = search.closest('[data-search-form]');
            let ww = $(window).width();

            if (ww < 992) {
                $(this).hide()
                form.slideDown('fast');
                form.addClass('open');
            }

            e.preventDefault();
        });

        $(window).off('resize').on('resize', function() {
            suggestions.children().removeAttr('style');
            body.removeClass('overflow-y');

            if ($(window).width() < 992) {
                category.hide()
            } else {
                category.show()
            }
        });

        $(window).on('scroll', function() {
            let top = $(window).scrollTop();
            let form = search.closest('[data-search-form]');
            let ww = $(window).width();
            let hh = $(window).height() * 2 / 3;

            if (ww > 991) {
                if (top > hh) {
                    suggestions.hide();
                    form.removeClass('active');
                }

                form.removeAttr('style');
                searchIcon.removeAttr('style');
            } else {
                if (!form.hasClass('active')) {
                    if (top > 1 && !form.hasClass('open')) {
                        form.slideUp('fast');
                        searchIcon.show()
                    } else {
                        form.slideDown('fast');
                        searchIcon.hide()
                    }
                }
            }
        });

        $(document).on('click', function(e) {
            let form = search.closest('[data-search-form]');
            let ww = $(window).width();

            if (ww > 991) {
                if (!search.is(e.target) && !suggestions.is(e.target) && suggestions.has(e.target).length === 0) {
                    suggestions.hide();
                    form.removeClass('active');
                }
                ;
            }
        });
    }

    // загрузка фото при поиске
    updateLazy()
    {
        let search = this.input;
        let suggestions = search.closest('form').find('[data-suggestions]');
        let searchResults = suggestions.find('[data-suggestions-results]');
        let img = searchResults.find('.lazyload');
        let lazy = new LazyLoad(img);
        lazy.loadImages();
    }

    // поиск городов
    initializeCity()
    {
        const that = this;
        let city = this.input;
        let btn = city.closest('form').find('[data-find-city-btn]');
        let form = city.closest('form');

        function iOS()
        {
            return [
                    'iPad Simulator',
                    'iPhone Simulator',
                    'iPod Simulator',
                    'iPad',
                    'iPhone',
                    'iPod'
                ].includes(navigator.platform)
                // iPad on iOS 13 detection
                || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
        }

        if (iOS() && city.closest('[data-city-parent]').length > 0) {
            let parent = city.closest('[data-city-parent]');
            city.on('focus', function() {
                setTimeout(() => {
                    $('html').css({
                        '--app-height': `${window.innerHeight}px`,
                        '--app-vh': `${window.innerHeight / 100}px`
                    });
                    $('html body').animate({scrollTop: $('body').offset().top}, 0);
                }, 0)
            });

            city.on('blur', function() {
                setTimeout(() => {
                    $('html').css({
                        '--app-height': `${window.innerHeight}px`,
                        '--app-vh': `${window.innerHeight / 100}px`
                    });
                    $('html body').animate({scrollTop: $('body').offset().top}, 0);
                }, 0)
            })
        }


        if (process.env.NODE_ENV === 'development') {
            this.arReturn = [
                {
                    CITY_ID: "84",
                    CODE: "0000073738",
                    COUNTRY_ID: "1",
                    DEPTH_LEVEL: "2",
                    ID: "84",
                    LATITUDE: "0.000000",
                    LEFT_MARGIN: "168",
                    LOC_DEFAULT: "N",
                    LONGITUDE: "0.000000",
                    NAME_RU: "Москва",
                    PARENT_ID: "1",
                    PATH: "Москва",
                    REGION_ID: null,
                    RIGHT_MARGIN: "1181",
                    SORT: "100",
                    TYPE_CODE: "CITY",
                    TYPE_ID: "5",
                    ZIP: "101000",
                },
                {
                    CITY_ID: null,
                    CODE: "0000244853",
                    COUNTRY_ID: null,
                    DEPTH_LEVEL: "4",
                    ID: "59444",
                    LATITUDE: "0.000000",
                    LEFT_MARGIN: "321812",
                    LOC_DEFAULT: "N",
                    LONGITUDE: "0.000000",
                    NAME_RU: "Москва деревня",
                    PARENT_ID: "832",
                    PATH: "Москва деревня, Пеновский район, Тверская область",
                    REGION_ID: null,
                    RIGHT_MARGIN: "321813",
                    SORT: "100",
                    TYPE_CODE: "VILLAGE",
                    TYPE_ID: "6",
                    ZIP: "172796"
                },
                {
                    CITY_ID: null,
                    CODE: "0000372698",
                    COUNTRY_ID: null,
                    DEPTH_LEVEL: "4",
                    ID: "113984",
                    LATITUDE: "0.000000",
                    LEFT_MARGIN: "210530",
                    LOC_DEFAULT: "N",
                    LONGITUDE: "0.000000",
                    NAME_RU: "Москва деревня",
                    PARENT_ID: "1512",
                    PATH: "Москва деревня, Порховский район, Псковская область",
                    REGION_ID: null,
                    RIGHT_MARGIN: "210531",
                    SORT: "100",
                    TYPE_CODE: "VILLAGE",
                    TYPE_ID: "6",
                    ZIP: "182620"
                },
                {
                    CITY_ID: null,
                    CODE: "0000587518",
                    COUNTRY_ID: null,
                    DEPTH_LEVEL: "4",
                    ID: "142881",
                    LATITUDE: "0.000000",
                    LEFT_MARGIN: "151678",
                    LOC_DEFAULT: "N",
                    LONGITUDE: "0.000000",
                    NAME_RU: "Москва деревня",
                    PARENT_ID: "2432",
                    PATH: "Москва деревня, Верхошижемский район, Кировская область",
                    REGION_ID: null,
                    RIGHT_MARGIN: "151679",
                    SORT: "100",
                    TYPE_CODE: "VILLAGE",
                    TYPE_ID: "6",
                    ZIP: "613310"
                },
                {
                    CITY_ID: null,
                    CODE: "0000062456",
                    COUNTRY_ID: null,
                    DEPTH_LEVEL: "5",
                    ID: "15007",
                    LATITUDE: "0.000000",
                    LEFT_MARGIN: "411585",
                    LOC_DEFAULT: "N",
                    LONGITUDE: "0.000000",
                    NAME_RU: "Москва снт",
                    PARENT_ID: "15002",
                    PATH: "Москва снт, Ильинки деревня, Сергиево-Посадский район, Московская область",
                    REGION_ID: null,
                    RIGHT_MARGIN: "411586",
                    SORT: "100",
                    TYPE_CODE: "VILLAGE",
                    TYPE_ID: "6",
                    ZIP: "141325"
                },
                {
                    CITY_ID: null,
                    CODE: "0000064085",
                    COUNTRY_ID: null,
                    DEPTH_LEVEL: "5",
                    ID: "15873",
                    LATITUDE: "0.000000",
                    LEFT_MARGIN: "410575",
                    LOC_DEFAULT: "N",
                    LONGITUDE: "0.000000",
                    NAME_RU: "Москва снт",
                    PARENT_ID: "15871",
                    PATH: "Москва снт, Озерецкое село, Сергиево-Посадский район, Московская область",
                    REGION_ID: null,
                    RIGHT_MARGIN: "410576",
                    SORT: "100",
                    TYPE_CODE: "VILLAGE",
                    TYPE_ID: "6",
                    ZIP: "141354"
                },
                {
                    CITY_ID: null,
                    CODE: "0000064086",
                    COUNTRY_ID: null,
                    DEPTH_LEVEL: "5",
                    ID: "15874",
                    LATITUDE: "0.000000",
                    LEFT_MARGIN: "410576",
                    LOC_DEFAULT: "N",
                    LONGITUDE: "0.000000",
                    NAME_RU: "Воронеж",
                    PARENT_ID: "15871",
                    PATH: "Воронеж, Воронежская область",
                    REGION_ID: null,
                    RIGHT_MARGIN: "410577",
                    SORT: "100",
                    TYPE_CODE: "VILLAGE",
                    TYPE_ID: "6",
                    ZIP: "141355"
                }
            ];
        }

        city.off('keyup').on('keyup', (e) => {
            this.findCityPopupAjax(e.target, this.arReturn);
        });

        form.on('submit', function(e) {
            e.preventDefault();

            let cityInput = $(this).find('[data-find-city]');

            if (cityInput.val().length > 0) {
                that.findCityPopupAjax(btn, that.arReturn);
            }
        });

        // btn.on('click', (e) => {
        //   let el = e.target.parentElement.previousElementSibling.querySelector('[data-find-city]');

        //   if(el.value != ""){
        //     this.findCityPopupAjax(el, this.arReturn);
        //   }

        //   e.preventDefault();
        // })

        $(document).on('click', '[data-location]', function(e) {
            let el = $(this);
            let form = el.closest('form');
            let location = el.attr('data-location');
            let locationId = el.attr('data-id');


            if (window.xhr_save_city && window.xhr_save_city.readyState != 4) {
                window.xhr_save_city.abort();
            }
            window.xhr_save_city = $.post(window.langUrl + '/local/ajax/save-city.php', {id: locationId}, function() {

                if (window.redirectAfterCityChange > '') {
                    location.href = window.redirectAfterCityChange;
                } else if (window.isOrderPage == true) {
                    submitForm('N', locationId); // init in order script
                } else {
                    const contactInfo = Array.from($('[data-contact-info]')).map(e => {
                        return {
                            name: e.getAttribute('name'),
                            value: e.value
                        }
                    });
                    if (contactInfo.length)
                        $.cookie('contactInfo', JSON.stringify(contactInfo), {expires: 10 / 24 / 3600, path: '/'});
                    //location.href = location.href; // после смены города нужно обновить страницу (кеш каталога разный)
                    window.location.reload();
                }
            });

            city.val(location);
            form.find('[data-location-id]').val(locationId);
            $('[data-user-city]').text(location)

            if ($('.mfp-ready').length > 0) {
                $.magnificPopup.close();
            }

            e.preventDefault();
        });
    }

    findCityPopupAjax(el)
    {
        let value = el.value;
        let form = el.closest('form').getAttribute('id');
        form = $('#' + form);
        let parent = form.closest('[data-city-parent]');
        let method = form.attr('method') || "GET";
        let requestData = form.serialize();

        let url = el.dataset.ajaxUrl;
        if (!url) {
            url = form.attr('action');
        }

        if (value.length > 2) {

            if ($('[data-preloader]').length > 0) {
                $('[data-preloader]').show();
            }
            if (window.xhr_search_city && window.xhr_search_city.readyState != 4) {
                window.xhr_search_city.abort();
            }
            window.xhr_search_city = $.ajax({
                url: url,
                method: method,
                dataType: 'json',
                data: requestData
            }).done((response) => {
                this.findCity(response, value, parent);

                if ($('[data-preloader]').length > 0) {
                    $('[data-preloader]').hide();
                }
            }).fail(() => {

            });
        }

        if (value.length == 0) {
            this.loadBasedata(parent);
        }
    }

    // поиск города в массиве
    findCity(response, val, parent)
    {
        let cities = response['data']['ITEMS']
        let list = parent.find('[data-list-city]');
        let total = 0;
        list.html('');

        for (let i = 0; i < cities.length; i++) {
            let value = cities[i]['VALUE'];

            if (value) {
                let template = '';
                if (typeof (cities[i]['PATH_NAME'][0]) != 'undefined') {
                    template = `<div class="popup__city-item"><a href="#" class="popup__city-link" data-id="${cities[i]['VALUE']}" data-location="${cities[i]['DISPLAY']}">${cities[i]['DISPLAY']}<span class="popup__city-subtext">${cities[i]['PATH_NAME'][0]}</span></a></div>`;
                } else {
                    template = `<div class="popup__city-item"><a href="#" class="popup__city-link" data-id="${cities[i]['VALUE']}" data-location="${cities[i]['DISPLAY']}">${cities[i]['DISPLAY']}<span class="popup__city-subtext"></span></a></div>`;
                }
                list.append(template);
                total++;
            }
        }

        if (total == 0) {
            list.append('<div>По Вашему запросу ничего не найдено</div>');
        }
    }

    // загрузка базового списка городов
    loadBasedata(parent)
    {
        let list = parent.find('[data-list-city]');
        let cities = [];
        list.html('');

        if (typeof window.default_locations != 'undefined') {
            cities = window.default_locations;
        }

        if (cities.length > 0) {
            for (let i = 0; i < cities.length; i++) {
                let template = `<div class="popup__city-item"><a href="#" class="popup__city-link" data-id="${cities[i]['CITY_ID']}" data-location="${cities[i]['NAME_RU']}">${cities[i]['NAME_RU']}</a></div>`;
                list.append(template);
            }
        } else {
            list.append('<div>По Вашему запросу ничего не найдено</div>');
        }
    }

    // скрытие / отображение пароля
    passwordChange()
    {
        let textHide = this.input.attr('data-input-button');
        let textShow = this.input.text();

        this.input.on('click', function(e) {
            let el = $(this);
            let input = el.parent().find('input');

            if (input.prop('type') === 'password') {
                input.prop('type', 'text');
                el.text(textHide);
            } else {
                input.prop('type', 'password');
                el.text(textShow);
            }
        });
    }
}

export {Input};

$(window).on('load', () => {
    let inputs = [];
    let inputsCity = [];
    let inputsSearch = [];
    let inputsButtons = [];


    if ($('[data-input]').length > 0) {
        $('[data-input]').each(function(i) {
            inputs[i] = new Input($(this));
            inputs[i].initialize();
        });
    }

    if ($('[data-find-city]').length > 0) {
        $('[data-find-city]').each(function(i) {
            inputsCity[i] = new Input($(this));
            inputsCity[i].initializeCity();
        });
    }

    if ($('[data-search]').length > 0) {
        $('[data-search]').each(function(i) {
            inputsSearch[i] = new Input($(this));
            inputsSearch[i].initializeSearch();
        });
    }

    if ($('[data-input-button]').length > 0) {
        $('[data-input-button]').each(function(i) {
            inputsButtons[i] = new Input($(this));
            inputsButtons[i].passwordChange();
        });
    }
});
